import logo from '../../assets/sultan-logo.jpg'

type Props = {
  className?: string
  title?: string
}

export default function BrandMark({ className, title = 'Sultan Motors' }: Props) {
  return <img src={logo} alt={title} className={className} />
}
